import styles from 'components/Toolbar/toolbar.module.scss';
import React from 'react';

export const Toolbar = (props: React.PropsWithChildren): React.ReactElement => {
  return <div className={styles.toolbar}>{props.children}</div>;
};
